"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlHelper = exports.PATH_DOMAIN = void 0;
var environment_helper_1 = require("./environment.helper");
exports.PATH_DOMAIN = {
    LOCALHOST: "localhost",
    SIT: "sit",
    QA: "qa",
    DEV: "dev",
    PROD: "prod",
    EVO_SIT: "evo-sit",
    EVO_DEV: "evo-dev",
    AUTHORING_INTE: "authoring-inte",
    AUTHORING_SVIL: "authoring-svil",
    AUTHORING_COLL: "authoring-coll"
};
exports.UrlHelper = {
    isAFullUrl: function (pathOrUrl) {
        return new RegExp("^(http|https)://", "i").test(pathOrUrl);
    },
    isAFullUrlWithQueryString: function (pathOrUrl) {
        return this.isAFullUrl(pathOrUrl) && /\?.+=/.test(pathOrUrl);
    },
    redirectURL: function (url, mapping) {
        var match = Object.keys(mapping).find(function (regex) {
            return new RegExp(regex).test(url);
        });
        return match ? mapping[match] : null;
    },
    completeUrl: function (pathOrUrl, baseUrl) {
        if (this.isAFullUrl(pathOrUrl)) {
            return pathOrUrl;
        }
        else {
            var urlObject = new URL(pathOrUrl, baseUrl);
            return urlObject.href;
        }
    },
    completeUrlWithCurrentOrigin: function (pathOrUrl) {
        return environment_helper_1.EnvironmentHelper.isClientSide()
            ? this.completeUrl(pathOrUrl, window.location.origin)
            : pathOrUrl;
    },
    extractPathFromUrl: function (url) {
        if (this.isAFullUrl(url)) {
            var urlObject = new URL(url);
            return urlObject.pathname;
        }
        else {
            return url;
        }
    },
    isSSGPageUrl: function (url) {
        return !this.isSSRPageUrl(url);
    },
    isSSRPageUrl: function (url) {
        return false; // new RegExp(PRIVATE_ROUTE_PATH).test(url); // All pages are pre-rendered with SSG
    },
    isHCLAuthoringPageUrl: function (url) {
        return (new RegExp(/authoring(-[a-zA-Z]+)?\.unipolsai\.it/).test(url) ||
            new RegExp(/axintpd01\.servizi\.gr-u\.it/).test(url) || // TODO - NEED TO BE REMOVED AFTER INTE RELEASE WITH F5 ENDPOINT
            new RegExp(/axintpd02\.servizi\.gr-u\.it/).test(url) || // TODO - NEED TO BE REMOVED AFTER INTE RELEASE WITH F5 ENDPOINT
            (this.isStaticFilePageUrl(url) &&
                new RegExp(/.*\/authoring\/.*\.html$/).test(url)) // use for local testing purpose
        );
    },
    isStaticFilePageUrl: function (url) {
        return new RegExp(/^file:\/\//).test(url); // use for local testing purpose
    },
    isNewArchitecturePageUrl: function (url) {
        return new RegExp(/^https:?\/\/((dev|sit|qa|fix|www|authoring-inte|authoring-svil|authoring-coll|authoring)\.)?unipolsai\.it/).test(url) || new RegExp(/^https:?\/\/((dev|sit|qa|fix|www|authoring-inte|authoring-svil|authoring-coll|authoring)\.)?unipol\.it/).test(url);
    },
    isOldArchitecturePageUrl: function (url) {
        return new RegExp(/^https:?\/\/(svil|inte|coll)\.unipolsai\.it/).test(url);
    },
    getProjectNameFromUrl: function () {
        var projectName = undefined;
        if (environment_helper_1.EnvironmentHelper.isClientSide() &&
            exports.UrlHelper.isHCLAuthoringPageUrl(window.location.href)) {
            var url = window.location.href;
            var projectPosition = url.indexOf("$project/");
            if (projectPosition !== -1) {
                var splittedUrl = url.substring(projectPosition).split("/");
                if (splittedUrl.length > 1 && splittedUrl[1]) {
                    projectName = splittedUrl[1];
                }
            }
        }
        return projectName;
    },
    rewriteImagePath: function (url) {
        // if (
        //   !PageHelper.isHCLAuthoringPage() &&
        //   new RegExp("^/wcm/myconnect/").test(url)
        // ) {
        //   return url.replace(
        //     "/wcm/myconnect/",
        //     "/wcm/connect/"
        //   );
        // } else {
        //   return url;
        // }
        return url;
    },
    cleanCMSPathname: function (url) {
        var _a = url.match(/\/tpdweb\/(.*?)\/!ut/) || [], _ = _a[0], newUrl1 = _a[1];
        if (newUrl1 && newUrl1.length) {
            return "/".concat(newUrl1);
        }
        var _b = url.match(/\/tpdweb\/(.*?)$/) || [], __ = _b[0], newUrl2 = _b[1];
        if (newUrl2 && newUrl2.length) {
            return "/".concat(newUrl2);
        }
        var _c = url.match(/\/myportal\/(.*?)$/) || [], ____ = _c[0], newUrl3 = _c[1];
        if (newUrl3 && newUrl3.length) {
            return "/".concat(newUrl3);
        }
        return url;
    },
    isHostUrlEqualToPageUrl: function (hostUrl, pageUrl) {
        return hostUrl === this.cleanCMSPathname(pageUrl);
    },
    isHostUrlSubPathOf: function (hostUrl, pageCategory) {
        return (this.isHostUrlEqualToPageUrl(hostUrl, "/".concat(pageCategory)) ||
            hostUrl.startsWith("/".concat(pageCategory, "/")));
    },
    getYoutubeId: function (url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        var match = url.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
    },
    getIframeSrc: function (youtubeURL) {
        var youtubeVideoId = this.getYoutubeId(youtubeURL);
        var iframeSrc = "";
        var protocol = environment_helper_1.EnvironmentHelper.isLocalEnvironment() ? "http" : "https";
        if (youtubeVideoId) {
            iframeSrc = "".concat(protocol, "://www.youtube.com/embed/").concat(youtubeVideoId);
        }
        else if (youtubeURL) {
            /** youtubeURL is an ID, it doens't match the regex for the full URL */
            iframeSrc = "".concat(protocol, "://www.youtube.com/embed/").concat(youtubeURL);
        }
        return iframeSrc;
    },
    generateHrefFrom: function (_a) {
        var telephone = _a.telephone, email = _a.email, url = _a.url;
        var href = "";
        if (!!telephone) {
            href = "tel:".concat(telephone);
        }
        else if (!!email) {
            href = "mailto:".concat(email);
        }
        else if (!!url) {
            href = url;
        }
        else {
            href = "javascript:void(0)";
        }
        return href;
    },
    isRelativeUrl: function (url) {
        //regex per verfificare se il path inizia con .../ o con ../
        var regex = /^(?:\.\.\.\/|\.\.\/)/;
        return regex.test(url);
    },
    /**
     * Verifica se l'ambiente (o gli ambienti) in cui ci troviamo sia quello passato come argomento
     * @param {TUrlDomain[]} domainsToBeChecked
     * @returns {boolean}
     */
    checkIfEnvironmentIs: function (domainsToBeChecked) {
        var DOMAINS = {
            localhost: "http://localhost:",
            sit: "https://sit.unipol.it",
            qa: "https://qa.unipol.it",
            dev: "https://dev.unipol.it",
            prod: "https://www.unipol.it",
            "evo-sit": "https://evo-sit.unipolsai.it",
            "evo-dev": "https://evo-dev.unipolsai.it",
            "authoring-inte": "https://authoring-inte.unipolsai.it/",
            "authoring-svil": "https://authoring-svil.unipolsai.it/",
            "authoring-coll": "https://authoring-coll.unipolsai.it/",
        };
        if (environment_helper_1.EnvironmentHelper.isClientSide()) {
            var currentUrl_1 = window.location.href;
            var result_1 = false;
            // domainsToBeChecked.map((domain) => {
            //   if (currentUrl.includes(DOMAINS[domain])) result = true;
            // });
            domainsToBeChecked.forEach(function (domain) {
                if (currentUrl_1.includes(DOMAINS[domain]))
                    result_1 = true;
            });
            return result_1;
        }
        else
            return false;
    },
};
